import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { Constants } from '../../../model/common.model';
import { PanelModule } from '../../../modules/panel.module';
import { TagSelectorComponent } from '../tag-selector/tag-selector.component';

@Component({
  selector: 'brt-menu-option-save',
  standalone: true,
  imports: [PanelModule, TagSelectorComponent],
  templateUrl: './menu-option-save.component.html',
  styleUrl: './menu-option-save.component.scss'
})
export class MenuOptionSaveComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  types = Constants.MenuItemOptionTypes;
  businessId: any;
  menuId: any;
  menuOptionId: any;
  menuOption: any;
  constructor(private route: ActivatedRoute, private router: Router, private menuService: MenuService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      this.menuOptionId = params['id'];
      await this.load();
    });
  }

  async load() {
    if (!this.menuOptionId)
      this.menuOption = { BusinessId: this.businessId };
    else
      this.menuOption = await this.menuService.getMenuOption(this.menuOptionId);
  }

  async save(navigate = true) {
    await this.menuService.saveMenuOption(this.menuOption);
    if (navigate) {
        if(window.history?.length) window.history.back()      
        else await this.router.navigate([this.basePath, 'menu', this.businessId, this.menuId].filter(_ => _));
    } 
  }
}
